<template>
  <div class="modal fade" :id="id" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="text-right">
          <div class="cancel" @click="reset">
            <img
              src="../../../public/static/images/icons/close_icon.svg"
              class="small"
              alt="close-icon"
            />
          </div>
        </div>
        <div class="text-center">
          <div class="text-center">
            <img
              src="../../../public/static/images/icons/expiring_soon.svg"
              alt="expiringsoon-icon"
            />
          </div>
          <template v-if="!isGlobalSearch && !isCountryNotSubscribed">
            <p class="title">
              The market is not available as you are not subscribed to this country
            </p>
            <p class="desc">
              Please visit <a class="link" href="/layout/market-place/service/2">Marketplace</a> and
              subscribe to this country as other markets are part of Regulatory Intelligence
              subscription in Marketplace.
            </p>
          </template>
          <template v-else>
            <p class="title" v-if="isGlobalSearch">
              This service is not available as you are not subscribed
            </p>
            <p class="title" v-else-if="isCountryNotSubscribed">This country is not selected.</p>
            <p class="desc" v-if="isGlobalSearch">
              Please visit
              <a class="link" :href="`/layout/market-place/service/${selectedServiceId}`"
                >Marketplace</a
              >
              and subscribe to this service.
            </p>
            <p class="desc" v-else-if="isCountryNotSubscribed">
              Regulatory updates are displayed based on countries selected under
              <a class="link cursor-pointer" @click.stop="openRegWatchInAccountSettings"
                >Account Settings</a
              >
              See all countries or customize based on your market interest.
            </p>
          </template>
        </div>
        <div class="row">
          <div class="text-center">
            <button class="ok-btn emergo-green-button" @click="reset">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';

export default {
  name: 'UnsubscribedCountryPopup',
  props: {
    id: {
      type: [String, Number]
    },
    isGlobalSearch: {
      type: Boolean,
      default: false
    },
    isCountryNotSubscribed: {
      type: Boolean,
      default: false
    },
    selectedServiceId: {
      default: null
    }
  },
  methods: {
    openRegWatchInAccountSettings() {
      this.reset();
      this.$emit('regWatchInAccountSettings');
    },
    reset() {
      if (this.isCountryNotSubscribed) this.$emit('setGlobalSearch');
      $(`#${this.id}`).modal('hide');
    },
    open() {
      this.$router.push({
        path: '/layout/market-place/service/2'
      });
    }
  }
};
</script>
<style scoped>
.modal-content {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
}
.cancel {
  cursor: pointer;
}
img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}
img.small {
  width: 24px;
  height: 24px;
}
.ok-btn {
  width: 160px;
  height: 36px;
  margin-bottom: 5px;
}
p.title {
  font-size: 24px;
  font-weight: 400;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.7);
  padding-top: 20px;
  padding-bottom: 40px;
}
p.desc {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  padding-bottom: 40px;
  padding-left: 50px;
  padding-right: 50px;
}
</style>
